import {FunctionComponent, HTMLAttributes} from 'react';
import clsx from 'clsx';
import {twMerge} from 'tailwind-merge';

type MessageVariant = 'primary' | 'success' | 'error' | 'warning';
type MessageSize = 'base' | 'small';

interface ElementProps extends HTMLAttributes<HTMLDivElement> {
  text: string;
  dataTestid: string;
  variant?: MessageVariant;
  size?: MessageSize;
}

const Message: FunctionComponent<ElementProps> = ({text, dataTestid, variant, size}) => {
  if (!text) return;

  const variantClasses = clsx(
    'peer w-full rounded-2 bg-grey-100 px-6 py-4 text-lg text-violet *:mb-4 last:*:mb-0 peer-[]:mt-4',
    variant === 'success' && 'bg-green-50 text-green-500',
    variant === 'warning' && 'bg-amber-100 text-amber-600',
    variant === 'error' && 'bg-red-100 text-red',
    size === 'small' && '-my-2 px-4 py-2 text-sm',
  );

  return <div data-testid={dataTestid} className={twMerge(variantClasses)} dangerouslySetInnerHTML={{__html: text}} />;
};

export default Message;
